/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactInfo } from './ContactInfo';
import {
    ContactInfoFromJSON,
    ContactInfoFromJSONTyped,
    ContactInfoToJSON,
} from './ContactInfo';

/**
 * Contact details
 * @export
 * @interface UserProfileDetails
 */
export interface UserProfileDetails {
    /**
     * 
     * @type {string}
     * @memberof UserProfileDetails
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDetails
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDetails
     */
    lastName: string;
    /**
     * 
     * @type {ContactInfo}
     * @memberof UserProfileDetails
     */
    contactInfo?: ContactInfo;
}

/**
 * Check if a given object implements the UserProfileDetails interface.
 */
export function instanceOfUserProfileDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;

    return isInstance;
}

export function UserProfileDetailsFromJSON(json: any): UserProfileDetails {
    return UserProfileDetailsFromJSONTyped(json, false);
}

export function UserProfileDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'contactInfo': !exists(json, 'contactInfo') ? undefined : ContactInfoFromJSON(json['contactInfo']),
    };
}

export function UserProfileDetailsToJSON(value?: UserProfileDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'contactInfo': ContactInfoToJSON(value.contactInfo),
    };
}

